import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../i18n/translate.js';
import SidePanelInfoBox from '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import styles from './DevicesAutomaticallyAdjustedForPets.module.scss.js';

var DevicesAutomaticallyAdjustedForPets = function DevicesAutomaticallyAdjustedForPets(_ref) {
  var devices = _ref.devices;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SidePanelInfoBox, {
    className: styles.sidePanelInfoBox,
    title: t('MPLIB_PET_SETTINGS_AUTO_ADJUST_DEVICE_TITLE'),
    text: t('MPLIB_PET_SETTINGS_AUTO_ADJUST_DEVICE_DESCR')
  }), /*#__PURE__*/React.createElement("ul", {
    className: styles.devices
  }, devices.map(function (device) {
    return /*#__PURE__*/React.createElement("li", {
      key: device.deviceLabel
    }, device.area);
  })));
};
DevicesAutomaticallyAdjustedForPets.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.shape({
    area: PropTypes.string,
    deviceLabel: PropTypes.string
  }))
};
DevicesAutomaticallyAdjustedForPets.defaultProps = {
  devices: []
};

export { DevicesAutomaticallyAdjustedForPets as default };
